import type { PublicApiKey } from '@/apilib';
import type { createEditorCoreApi } from './api';

export const EditorCoreApiKey: PublicApiKey<typeof createEditorCoreApi> = {
  name: 'EditorCoreApi',
  public: true,
};
